export default "__VITE_ASSET__B5Q9h32r__"